import Draggable24 from '@carbon/icons-react/es/draggable/24';
import React from 'react';
import styled from 'styled-components';
import { ReactCompareSliderCommonProps } from './types';

const HandleButton = styled.div`
  width: 70px;
  height: 50px;
  background: linear-gradient(
    115.09deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
`;

const OverlayHandle = styled.div`
  width: 58px;
  height: 38px;
  background: #ffffff;

  box-shadow: 0px 1.6px 3.6px rgba(0, 0, 0, 0.13),
    0px 0.3px 0.9px rgba(0, 0, 0, 0.11);
  border-radius: 20px;
  margin: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
`;

const DraggableIcon = styled(Draggable24)`
  color: var(--gray-40);
  cursor: grab;
`;

/** Props for `ReactCompareSliderHandle`. */
export interface ReactCompareSliderHandleProps
  extends Pick<ReactCompareSliderCommonProps, 'portrait'> {
  /** Optional styles for handle the button. */
  buttonStyle?: React.CSSProperties;
  /** Optional styles for lines either side of the handle button. */
  linesStyle?: React.CSSProperties;
  /** Optional styles for the handle root. */
  style?: React.CSSProperties;
  isPointerDown: boolean;
}

/** Default `handle`. */
export const ReactCompareSliderHandle: React.FC<ReactCompareSliderHandleProps> =
  ({
    portrait,
    buttonStyle,
    linesStyle,
    style,
    isPointerDown,
    ...props
  }): React.ReactElement => {
    const _style: React.CSSProperties = isPointerDown
      ? {
          display: 'flex',
          flexDirection: portrait ? 'row' : 'column',
          placeItems: 'center',
          height: '100%',
          cursor: portrait ? 'ns-resize' : 'grabbing',
          pointerEvents: 'none',
          color: '#fff',
          margin: '0 300px',
          ...style,
        }
      : {
          display: 'flex',
          flexDirection: portrait ? 'row' : 'column',
          placeItems: 'center',
          height: '100%',
          cursor: portrait ? 'ns-resize' : 'grab',
          pointerEvents: 'none',
          color: '#fff',
          ...style,
        };

    const _linesStyle: React.CSSProperties = {
      flexGrow: 1,
      height: portrait ? 2 : '100%',
      width: portrait ? '100%' : 2,
      backgroundColor: 'currentColor',
      pointerEvents: 'auto',
      boxShadow: '0 0 7px rgba(0,0,0,.35)',
      ...linesStyle,
    };

    return (
      <div className="__rcs-handle-root" {...props} style={_style}>
        <div className="__rcs-handle-line" style={_linesStyle} />
        <HandleButton>
          <OverlayHandle>
            <DraggableIcon />
          </OverlayHandle>
        </HandleButton>
        <div className="__rcs-handle-line" style={_linesStyle} />
      </div>
    );
  };
